import React from "react";
import { Box, Typography } from "@mui/material";
import { ChipCustom } from "../../styles/styledComponents";

const HealthView = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4">
        <>
          <ChipCustom color="success" label="Healthy" />
          <span style={{ marginLeft: ".5rem" }}>Hey There!!! The App is Healthy.</span>
        </>
      </Typography>
    </Box>
  );
};

export default HealthView;
